import { render, staticRenderFns } from "./myPopconfirm.vue?vue&type=template&id=09816a92"
import script from "./myPopconfirm.vue?vue&type=script&lang=js"
export * from "./myPopconfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports